import {
  booleanAttribute,
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  inject,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: 'details[appExpansion]',
})
export class ExpansionDirective {
  private readonly nativeElement: HTMLDetailsElement = inject(ElementRef).nativeElement;

  @Input({ transform: booleanAttribute })
  @HostBinding('open')
  isOpen = false;

  @Output()
  isOpenChange = new EventEmitter<boolean>();

  @HostListener('toggle')
  onToggle(): void {
    this.isOpen = this.nativeElement.open;
    this.isOpenChange.emit(this.isOpen);
  }
}
